interface AnalyticsTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const tabOptions = [
  { key: "overview", label: "Overview" },
  { key: "trends", label: "Publication Trends" },
  { key: "collaborations", label: "Collaborations" },
  { key: "affiliations", label: "Affiliations" },
];

const AnalyticsTabs = ({ activeTab, setActiveTab }: AnalyticsTabsProps) => {
  return (
    <div className="flex flex-wrap justify-end md:justify-start gap-2 md:gap-4 mb-4 px-2">
      {tabOptions.map((tab) => (
        <button
          key={tab.key}
          onClick={() => setActiveTab(tab.key)}
          className={`text-sm sm:text-base px-3 sm:px-4 py-1 sm:py-2 rounded-lg font-semibold transition whitespace-nowrap ${
            activeTab === tab.key
              ? "bg-[#0B132B] text-white"
              : "bg-gray-200 text-[#1d244f]"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default AnalyticsTabs;
